<template>
  <div v-if='isArchived'>
    <v-tooltip top>
      <template v-slot:activator='{ on }'>
        <v-btn
          small
          :color='unarchiveColor'
          depressed
          dark
          v-on='on'
          @click="$emit('toggleArchive')"
        >
          <v-icon left>{{ unarchiveIcon }}</v-icon>
          {{ unarchiveButtonText }}
        </v-btn>
      </template>
      <span>
        {{ unarchiveText }}
      </span>
    </v-tooltip>
  </div>
  <div v-else>
    <v-tooltip top>
      <template v-slot:activator='{ on }'>
        <v-btn
          small
          v-on='on'
          icon
          @click="$emit('toggleArchive')"
        >
          <v-icon
            :color='archiveColor'
          >
            {{ archiveIcon }}
          </v-icon>
        </v-btn>
      </template>
      <span>
        {{ archiveText }}
      </span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  name: 'wc-archive-button',
  props: {
    isArchived: {
      required: true,
      type: Boolean
    },
    // All of the following for when it is in the UN-ARCHIVED state, and you want to
    // switch it to the Archived state
    archiveText: {
      required: false,
      default: 'Click to Archive'
    },
    archiveColor: {
      required: false,
      default: 'grey'
    },
    archiveIcon: {
      required: false,
      default: 'mdi-archive'
    },
    // All of the following for when it is in the ARCHIVED state, and you want to
    // switch it to the UN-Archived state
    unarchiveText: {
      required: false,
      default: 'Click to UN-Archive'
    },
    unarchiveButtonText: {
      required: false,
      default: 'Archived'
    },
    unarchiveColor: {
      required: false,
      default: 'red'
    },
    unarchiveIcon: {
      required: false,
      default: 'mdi-archive'
    }
  }
}
</script>
